import { useMemo, ReactNode, createContext } from 'react';

import { FilesService } from '../files';
import { ImageConverter } from '../image-converter';
import { ImageRotator } from '../image-rotator';
import { Calendar } from '../calendar';
import { Logger } from '../logger';
import { FileType } from '../file-type';
import { VKHRTekUIServices } from '../types';
import { ValidationService } from '../validation';
import { FileCache } from '../file-cache';

export const ServicesContext = createContext<VKHRTekUIServices | null>(null);

type ServicesProviderProps = {
  services?: Partial<VKHRTekUIServices>;
  children: ReactNode | ReactNode[];
};

export const ServicesProvider = ({
  services,
  children,
}: ServicesProviderProps) => {
  const fullServices: VKHRTekUIServices = useMemo(() => {
    const logger = services?.logger ?? new Logger();
    const fileType = services?.fileType ?? new FileType(logger);
    const fileCache = services?.fileCache ?? new FileCache(logger, fileType);

    return {
      filesService: services?.filesService ?? new FilesService(),
      imageConverter: services?.imageConverter ?? new ImageConverter(),
      imageRotator: services?.imageRotator ?? new ImageRotator(),
      validation: services?.validation ?? new ValidationService(fileType),
      calendar: services?.calendar ?? new Calendar(),
      logger,
      fileCache,
      fileType,
      pdfWorkerSrc: services?.pdfWorkerSrc ?? '/pdf.worker.min.js',
    };
  }, [services]);

  return (
    <ServicesContext.Provider value={fullServices}>
      {children}
    </ServicesContext.Provider>
  );
};
